/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XButton from "vux/src/components/x-button/index.vue";
import { getCostAccessoryGetList, getCostAccessoryList } from '@/api';
export default {
  name: 'Enclosure',
  props: {
    code: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: [String, Number],
      default: 1
    }
  },
  components: {
    XButton: XButton
  },
  data: function data() {
    return {
      fileList: [],
      titleMap: {
        1: '配件申请',
        2: '费用报销'
      }
    };
  },
  mounted: function mounted() {
    document.documentElement.style['font-size'] = '12px';
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var func, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                func = Number(_this.type) === 1 ? getCostAccessoryGetList : getCostAccessoryList;
                _context.next = 3;
                return func({
                  id: _this.code
                });

              case 3:
                res = _context.sent;

                if (res.data.code === 0) {
                  _this.fileList = res.data.list || [];
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getFileName: function getFileName(item) {
      try {
        var value = item.slice(item.lastIndexOf('/') + 1);
        return /\d+-.+/.test(value) ? value.split('-').slice(1).join('-') : value;
      } catch (error) {
        return '附件';
      }
    }
  },
  created: function created() {
    if (this.code) {
      this.init();
    }
  }
};